<template>
  <div
    :class="customClass"
    class="box-application relative rounded shadow-lg p-4 font-bold text-blue hover:opacity-75 h-full text-center"
  >
    <h3 class="mb-6 text-base text-center ecosystem-application-title">
      {{ $t("ecosystem." + type.toLowerCase()) }}
    </h3>
    <!-- START APPLICATION DESCRIPTION -->
      <div class="mb-2 m-auto max-w-xs" v-if="$te('ecosystem.description_' + type.toLowerCase())">
        <span>{{ $t('ecosystem.description_' + type.toLowerCase()) }}</span>
      </div>
    <!-- END APPLICATION DESCRIPTION -->
    <div class="mb-4 h-16">
      <img
        class="fill-current"
        :src="appIcon.path"
        :alt="appIcon.text"
        :title="appIcon.text"
      />
    </div>
    <div class="mb-3 p-25" v-if="type == 'Deal' && !dependent">
      <p>{{ $t("ecosystem.not_apply_deal_message") }}</p>
    </div>
    <div class="mb-3 p-25" v-if="type == 'Sail' && !dependent">
      <p>{{ $t("ecosystem.not_apply_sail_message") }}</p>
    </div>
    <div class="mb-2" v-if="application">
      <span v-if="application.status == '0'">{{
        $t("candidat.being_entered")
      }}</span>
      <span v-if="['11'].includes(application.status)">{{
        $t("candidat.Awaiting_further_information")
      }}</span>
      <span v-if="!application.result && !['0', '11'].includes(application.status) || ['1', '2', '4', '5'].includes(application.status) || (application.result && application.result.status != '2' && !['0', '11'].includes(application.status))">{{
        $t("candidat.submitted_instruction")
      }}</span>
      <span v-if="application.result && application.result.status == '2' && ['3', '6', '8', '9'].includes(application.status)">
        <span v-if="['3', '6', '8'].includes(application.status)">{{
          $t("candidat.Refused")
        }}</span>
        <span v-if="['9'].includes(application.status)">{{
          $t("candidat.candidature_accepted")
        }}</span>
      </span>
    </div>
    <div v-else class="mb-2 invisible">
      <span>{{
        $t("team.status")
      }}</span>
    </div>
    <sp-button
      @click="
        application == null
          ? createEcosystemApp(type.toLowerCase())
          : application.status == '0' || application.status == '11'
          ? editEcosystemApp(application.hash_id, type)
          : consultEcosystemApp(application.hash_id, type)
      "
      class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
      :disabled="!dependent || ['Certif', 'Deal', 'Sail'].includes(type) && 
                 (existSession == null || existSession.first_step_status == 0) && (!application)"
    >
      <img
        v-if="application == null"
        class="fill-current w-4 h-4 mr-2"
        src="../../assets/img/cand/Group Copy 2.svg"
        alt="startup tunisia action"
      />
      <img
        v-else-if="application.status == '0' || application.status == '11'"
        class="fill-current w-4 h-4 mr-2"
        src="../../assets/img/cand/pencil-write.svg"
        alt="startup tunisia action"
      />
      <span v-if="application == null">{{
        $t("ecosystem.new_ecosystem_app")
      }}</span>
      <span v-else>
        <div
          v-if="application.status == '0' || application.status == '11'">
          <span  v-if="application.user_id != currentUser.id">
            {{ $t("ecosystem.member_edit_app") }}
          </span>
          <span v-else>
             {{ $t("ecosystem.edit_app") }}
          </span>
        </div>
        <div v-else> 
          <span  v-if="application.user_id != currentUser.id">
            {{ $t("ecosystem.consult_memeber_app") }}
          </span>
          <span v-else>
             {{ $t("ecosystem.consult_app") }}
          </span></div>
      </span>
    </sp-button>
    <div
      v-if="
        application &&
          application.status == '0' &&
          currentUser.id == application.user_id
      "
      class="px-6 mt-4 text-center h-5"
    >
      <sp-button class="text-grey" @click="showDelete(application.hash_id)">
        <span>{{ $t("candidat.delete") }}</span>
      </sp-button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/spKit/Button.vue";
import { Fragment } from "vue-fragment";
import { mapGetters } from "vuex";
import {
  FETCH_ECOSYSTEM_APPLICATION,
  CREATE_ECOSYSTEM_APP
} from "@/store/actions.type";
import { SET_HashId } from "@/store/mutations.type";
export default {
  name: "EcosystemApplication",
  components: {
    "sp-button": Button,
    fragment: Fragment
  },
  data() {
    return {
      isCreated: false,
      existSession : this.$store.getters.ecosystemSession[this.type],
    };
  },
  created() {
    this.result = this.myFunction(this.type);
  },
  props: {
    type: {
      required: true,
      type: String,
      default: undefined
    },
    application: {
      required: false,
      type: Object,
      default: null
    },
    dependent: {
      required: false,
      type: Boolean,
      default: true
    },
    customClass: {
      required: false,
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(["ecosystemApp", "currentUser"]),
    appIcon() {
      return {
        path: require(`../../assets/img/${this.type.toLowerCase()}.svg`),
        text: `Startup Tunisia ${this.type} Logo`
      }
    }
  },
  methods: {
    myFunction(type) {
      let val;
      if(type) {
        let ssoTypesArray = Object.entries(this.$store.getters.ecosystemSession);
        if (ssoTypesArray) {
          ssoTypesArray.forEach(([key, value]) => {
            if(type == key) {
              val = value;
            }
          })
        } 
      }
      return val;
    },
    async consultEcosystemApp(hashId, type) {
      if (['Air', 'Air2', 'Certif', 'Deal', 'd4d', 'Sail'].includes(type)) {
        localStorage.setItem('ecosystem', true);
      }
      await this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, hashId);
      let self = this;

      if (
        ["9"].includes(this.ecosystemApp.application.status) &&
        this.ecosystemApp.application.result != null &&
        this.ecosystemApp.application.result.status == 2 &&
        this.ecosystemApp.application.declarationMenu
      ) {
        this.$router.push({
          name: 'Declarations',
          params: {
            app_id: hashId,
            appType: this.type.toLowerCase()
          }
        });
      } else if (["3", "5", "7", "8"].includes(this.ecosystemApp.application.status)) {
        this.$router.push({ name: 'Status', params: { app_id: hashId } });
      } else {
        this.$router.push({
          name: self.formatRouteName(this.ecosystemApp.application.route),
          params: {
            formName: this.ecosystemApp.application.route,
            ecoAppId: hashId,
            appType: type.toLowerCase()
          }
        });
      }
    },
    createEcosystemApp(type) {
      if (!this.isCreated) {
          let self = this;
          this.isCreated = true;
          this.$store
          .dispatch(CREATE_ECOSYSTEM_APP, type)
          .then(() => {
            if (['Air', 'Air2', 'Certif', 'Deal', 'd4d', 'Sail'].includes(type)) {
              localStorage.setItem('ecosystem', true);
            }
            this.$router.push({
              name: self.formatRouteName(this.ecosystemApp.application.route),
              params: {
                formName: this.ecosystemApp.application.route,
                ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
                appType: this.ecosystemApp.application.type.toLowerCase()
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async editEcosystemApp(hashId, type) {
      let self = this;
      await this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, hashId);
      if (['Air', 'Air2', 'Certif', 'Deal', 'd4d', 'Sail'].includes(type)) {
        localStorage.setItem('ecosystem', true);
      }

      this.$router.push({
        name: self.formatRouteName(this.ecosystemApp.application.route),
        params: {
          formName: this.ecosystemApp.application.route,
          ecoAppId: hashId,
          appType: type.toLowerCase()
        }
      });
    },
    showDelete(id) {
      this.$store.commit(SET_HashId, id);
      this.$modal.show("remove-app");
    },
    formatRouteName(route) {
      let blocks = route.split('-');
      blocks.forEach(function callback(element, index) {
        blocks[index] = element.charAt(0).toUpperCase()+element.slice(1);
      });

      return blocks.join('');
    }
  }
};
</script>

<style></style>
